module.exports = __webpack_public_path__ + "img/terrero.266426c0.png";